var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("emc-avatar-base", {
        attrs: {
          src: _vm.model.url_company_logo,
          width: _vm.width,
          height: _vm.height,
          model: _vm.model,
          tile: "",
          showCamera: false,
          iconDefault: "mdi-image-outline",
        },
        on: { onComplete: _vm.upload },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }